import { schema } from 'normalizr'
import upperCase from 'lodash/upperCase'
import { geocoding, GEOCODING_QUERY_PARAM } from '@infotech/geocoding'
import { CALL_API, createSelectorForEntityKey, createEntitiesSelector } from '@infotech/lib-api-middleware'

const GEO_CODING_SCHEMA_NAME = `geoCoding`

const GEO_CODING_SCHEMA = new schema.Entity(GEO_CODING_SCHEMA_NAME, {}, {
  idAttribute: ({ point = {} }) => {
    const { lat, lon } = point
    return `${lat}-${lon}`
  },
})

const getGeoCodingQuery = ({
  query,
  bbox,
  lon,
  lat,
}) => ({
  [GEOCODING_QUERY_PARAM]: query,
  bbox,
  lon,
  lat,
})

export const geoKeyFun = (value) => JSON.stringify(value)

export const geoCodingFetch = (params) => {
  const query = getGeoCodingQuery(params)
  const geoCodingAction = geocoding(query)
  return {
    type      : `FETCH_${upperCase(GEO_CODING_SCHEMA_NAME)}`,
    [CALL_API]: {
      ...geoCodingAction[CALL_API],
      entity : GEO_CODING_SCHEMA_NAME,
      key    : geoKeyFun(query),
      options: {
        ...geoCodingAction[CALL_API].options,
        schema: GEO_CODING_SCHEMA,
      },
    },
  }
}

export const geoCodingSelector = createSelectorForEntityKey(GEO_CODING_SCHEMA_NAME)

export const geoCodingEntitiesSelector = createEntitiesSelector(GEO_CODING_SCHEMA_NAME)
